import React, { useState } from 'react';

function FAQ({ items, title = 'Frequently Asked Questions' }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-16 bg-gray-50" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 id="faq-heading" className="text-3xl font-bold text-[#4a3f35] mb-8 text-center">{title}</h2>
      <div className="space-y-4">
        {items.map((item, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow">
            <button
                className="w-full px-6 py-4 text-left focus:outline-none"
              onClick={() => toggle(idx)}
              aria-expanded={openIndex === idx}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-medium text-[#4a3f35]">{item.question}</h3>
                  <span className="ml-6 flex-shrink-0">
                    {openIndex === idx ? (
                      <svg className="h-6 w-6 text-[#b87c4c]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                      </svg>
                    ) : (
                      <svg className="h-6 w-6 text-[#b87c4c]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </span>
                </div>
            </button>
              <div
                className={`px-6 pb-4 ${openIndex === idx ? 'block' : 'hidden'}`}
                aria-hidden={openIndex !== idx}
              >
                <div itemProp="text">
                  {typeof item.answer === 'string' ? (
                    <span>{item.answer}</span>
                  ) : Array.isArray(item.answer) ? (
                    <ul className="list-disc pl-6 space-y-1">
                      {item.answer.map((li, i) => (
                        <li key={i}>{li}</li>
                      ))}
                    </ul>
                  ) : item.answer && typeof item.answer === 'object' && item.answer.intro && item.answer.list ? (
                    <>
                      <p>{item.answer.intro}</p>
                      <ul className="list-disc pl-6 space-y-1">
                        {item.answer.list.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                      {item.answer.outro && <p>{item.answer.outro}</p>}
                    </>
                  ) : null}
                </div>
              </div>
          </div>
        ))}
      </div>
    </div>
    </section>
  );
}

export default FAQ; 